"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Item = exports.ContainerItems = exports.ContainerWrapper = exports.Title = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const mobileWidth = '510px';
exports.Title = styled_components_1.default.span `
  font-size: 30px;
  margin-left: 25px;
  span {
    font-weight: 500;
    color: #ac1841;
  }
`;
exports.ContainerWrapper = styled_components_1.default.div `
  display: flex;

  justify-content: center;
  align-items: center;
  .group {
    width: 100%;
    margin: 20px 0;
    span:first-child {
      font-size: 1.1rem;
      color: #5e5e5e;
      font-weight: 500;
    }
  }
`;
exports.ContainerItems = styled_components_1.default.div `
  color: #000000;
  display: flex;
  flex-wrap: wrap;
  @media (max-width: ${mobileWidth}) {
    flex-direction: column;
  }
  .item {
    display: flex;
    width: 33%;
    justify-content: left;
    margin-top: 8px;
    span {
      margin-left: 10px;
      padding-top: 6px;
    }
    @media (max-width: ${mobileWidth}) {
      width: 70%;
    }
  }
`;
exports.Item = styled_components_1.default.div `
  display: flex;
  width: 45%;
  justify-content: left;
  margin-top: 8px;
  align-items: center;
  span {
    margin-left: 10px;
    padding-top: 6px;
  }
`;
